export function hasMonthlyPrice (prices: Array<any>): boolean {
    for (const price of prices) {
        if (price.recurrenceUnit === 'month') {
            return true;
        }
    }

    return false;
}

export function getMonthlyPrice (prices: Array<any>): number {
    for (const price of prices) {
        if (price.recurrenceUnit === 'month') {
            return price.value;
        }
    }

    return 0;
}

export function getMonthlyPriceRecurrenceEnd (prices: Array<any>): number {
    for (const price of prices) {
        if (price.recurrenceUnit === 'month') {
            return price.recurrenceEnd;
        }
    }

    return 0;
}

export function hasOnetimePrice (prices: Array<any>): boolean {
    for (const price of prices) {
        if (price.recurrenceUnit === 'onetime') {
            return true;
        }
    }

    return false;
}

export function getOnetimePrice (prices: Array<any>): number {
    for (const price of prices) {
        if (price.recurrenceUnit === 'onetime') {
            return price.value;
        }
    }

    return 0;
}

export function isPercentage (prices: Array<any>): boolean {
    for (const price of prices) {
        if (price.type === 'percentage') {
            return true;
        }
    }

    return false;
}



// WEBPACK FOOTER //
// ./app/bundles/enterprise-shop/src/api/utils/price-helpers.ts